import { render, staticRenderFns } from "./modal_calificaciones.vue?vue&type=template&id=3154c018"
import script from "./modal_calificaciones.vue?vue&type=script&lang=js"
export * from "./modal_calificaciones.vue?vue&type=script&lang=js"
import style0 from "./modal_calificaciones.vue?vue&type=style&index=0&id=3154c018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports